import { AlertTriangle, Clock } from "lucide-react";
import { cad } from "@/lib/pricing";

export const fmt = (minor, currency = "CAD") => (currency === "CAD"
  ? cad((minor || 0) / 100)
  : ((minor || 0) / 100).toLocaleString("en-CA", { style: "currency", currency }));

const LABELS = {
  MANUAL_ADMIN: "Manual (admin)", LEGACY_INSTANT: "Instant (legacy)", HELD: "Held", RELEASED: "Released", CONSUMED: "Used",
  RESTORED: "Restored", active: "Active", suspended: "Suspended", disabled: "Disabled", pending: "Pending",
};
export const label = (v) => (v == null || v === "" ? "—" : LABELS[v] || STATUS[v]?.[0] || String(v).replace(/_/g, " ").toLowerCase().replace(/^./, (c) => c.toUpperCase()));

export const when = (iso) =>
  iso ? new Date(iso).toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" }) : "—";

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.detail || fallback;
};

export const STATUS = {
  AWAITING_FULFILLMENT: ["Awaiting fulfilment", "bg-amber-50 text-amber-800 border-amber-200"],
  PROCESSING: ["Processing", "bg-cyan-50 text-cyan-800 border-cyan-200"],
  PENDING_SECOND_APPROVAL: ["Second approval", "bg-indigo-50 text-indigo-800 border-indigo-200"],
  NEEDS_REVIEW: ["Needs review", "bg-orange-50 text-orange-800 border-orange-200"],
  FULFILLED: ["Fulfilled", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  FAILED: ["Failed", "bg-rose-50 text-rose-800 border-rose-200"],
  CASHBACK_RESTORED: ["Cashback restored", "bg-slate-100 text-slate-700 border-slate-200"],
  VOIDED: ["Voided", "bg-slate-100 text-slate-500 border-slate-200"],
};

export const OPEN = ["AWAITING_FULFILLMENT", "PROCESSING", "NEEDS_REVIEW", "PENDING_SECOND_APPROVAL"];
export const FULFILLABLE = ["AWAITING_FULFILLMENT", "PROCESSING", "NEEDS_REVIEW"];

export function StatusChip({ status, testid }) {
  const [label, tone] = STATUS[status] || [status, "bg-slate-50 text-slate-600 border-slate-200"];
  return (
    <span className={`text-[10px] px-2 py-0.5 rounded-full border font-semibold uppercase tracking-widest whitespace-nowrap ${tone}`}
          data-testid={testid}>{label}</span>
  );
}

export function SlaBadge({ row, testid }) {
  if (row.sla_state === "overdue") {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-rose-700" data-testid={testid}>
        <AlertTriangle className="w-3 h-3" /> {row.sla_label}
      </span>
    );
  }
  if (row.sla_state === "due_soon") {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-amber-700" data-testid={testid}>
        <Clock className="w-3 h-3" /> {row.sla_label}
      </span>
    );
  }
  return null;
}

export function Section({ title, children, testid }) {
  return (
    <section className="border-t border-slate-100 pt-4" data-testid={testid}>
      <h3 className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold mb-2">{title}</h3>
      {children}
    </section>
  );
}

export function Field({ label, value, testid, mono }) {
  return (
    <div className="flex items-start justify-between gap-3 py-1 text-sm">
      <span className="text-slate-500 shrink-0">{label}</span>
      <span className={`text-slate-900 text-right break-all ${mono ? "font-mono text-xs" : ""}`} data-testid={testid}>{value ?? "—"}</span>
    </div>
  );
}
